export default __webpack_public_path__ + "static/pragicts-secops-services-swg-cdb096d30b2bfb97f5d63c266b62a314.jpg";